import { CheckSmallIcon } from '@/icons';
import { cn } from '@/utils';
import { BaseDropdownItemUI } from '../base/BaseDropdownItemUI';
import { SelectOnDrawerLayout } from './SelectOnDrawerLayout';
import { type SelectUIProps, type SingleSelectProps } from './type';
export const SingleSelectOnDrawerUI = <T extends string = string,>({
  showSelectedIcon = true,
  ...props
}: Omit<SingleSelectProps<T>, 'onValueChange' | 'valueRenderer'> & SelectUIProps & {
  onSelect: (value: T) => void;
}) => {
  return <SelectOnDrawerLayout {...props} data-sentry-element="SelectOnDrawerLayout" data-sentry-component="SingleSelectOnDrawerUI" data-sentry-source-file="SingleSelectOnDrawerUI.tsx">
      {props.options.map(option => <BaseDropdownItemUI key={option.value} onClick={() => props.onSelect(option.value)} checked={option.value === props.value} disabled={option.disabled || false} invalid={option.invalid || false} className={cn('justify-between text-body-lg-medium h-[44px]', props.className)}>
          {option.label}
          {showSelectedIcon && option.value === props.value && <CheckSmallIcon size="md" />}
        </BaseDropdownItemUI>)}
    </SelectOnDrawerLayout>;
};